/**
 * HelpIconButton Component
 * Small icon button that triggers help panel to open
 * Pattern: Atomic Design - Atoms
 */

import { IconButton, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export interface HelpIconButtonProps {
  onClick: () => void;
  'data-testid'?: string;
}

export function HelpIconButton({
  onClick,
  'data-testid': dataTestId = 'help-icon-button',
}: HelpIconButtonProps) {
  return (
    <Tooltip title="View help">
      <IconButton
        size="small"
        onClick={onClick}
        data-testid={dataTestId}
        sx={{
          color: 'action.active',
          transition: 'all 0.2s ease',
          '&:hover': {
            color: 'primary.main',
            backgroundColor: 'action.hover',
          },
        }}
      >
        <HelpOutlineIcon sx={{ fontSize: '0.75rem' }} />
      </IconButton>
    </Tooltip>
  );
}
